import { ReportClientParticipantLink } from '../../models/report-client-participant-link';
import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Subject, Subscription } from "rxjs";
import { DataTableDirective } from "angular-datatables";
import { UserDataStoreService } from "../../services/user-data-store.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MerchantService } from "../../services/merchant.service";
import { Router, ActivatedRoute } from '@angular/router';
import { PermissionEnum, AccessPolicyEnum } from "../../services/guards/permissions";
import { AuthenticationService } from "../../services/authentication.service";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HttpClient } from '@angular/common/http';
import { debounceTime, distinctUntilChanged, takeUntil } from "rxjs/operators";
import { DataTablesResponseViewModel } from '../../models/data-tables-response-view-model';
import { environment } from '../../../environments/environment';
import { MerchantReportDTViewModel } from '../../models/merchant-report-dt-view-model';
import { ReportService } from '../../services/report.service';
import { ToastrService } from 'ngx-toastr';
import { ParticipantViewModel } from '../../models/participant-view-model';
import { CreateResult } from '../../models/create-result';

@Component({
  selector: 'app-report-client-participant-link',
  templateUrl: './report-client-participant-link.component.html',
  styleUrls: ['./report-client-participant-link.component.scss']
})
export class ReportClientParticipantLinkComponent implements OnInit {

  public dtTrigger: Subject<boolean> = new Subject();
  public searchDebounce = new Subject<string>();
  public canManage = false;
  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;

  public dtOptions: DataTables.Settings = {};

  public clientParticipantLinks: ReportClientParticipantLink[];

  public clientParticipantLink: ReportClientParticipantLink;
  private _destroyed$ = new Subject<any>();

  public selectedParticipant: number;
  public selectedParticipants: string[] = [];
  public allParticipants: ParticipantViewModel[];
  public clientId: number;
  public raiseDanger: boolean;
  public error: string;
  public createResult: CreateResult;

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _toastService: ToastrService,
    private _modalService: NgbModal,
    private _authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private _userDataStore: UserDataStoreService,
    private _router: Router,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _reportService: ReportService,
    private _ngxLoader: NgxUiLoaderService) {

    this.canManage = this._userDataStore.hasRequiredPermissions([PermissionEnum.ManageTutukaManagementReportSetups]);
    if (!this.canManage) {
      this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
      this._router.navigate(['/']);
    }

    route.params.pipe(takeUntil(this._destroyed$)).subscribe(async params => {

      this.clientParticipantLinks = await this._reportService.GetClientParticipantLinks();
      this.allParticipants = await this._reportService.GetAllParticipants();

    });
  }

  public async save(): Promise<void> {

    if (this.clientId <= 0 || this.clientId == undefined) {
      this.raiseDanger = true;
      this.error = "Client is required and must be numeric only!";
      return;
    }

    if (this.selectedParticipant <= 0 || this.selectedParticipant == undefined) {
      this.raiseDanger = true;
      this.error = "Participant is required!";
      return;
    }

    this.raiseDanger = false;
    this.error = "";
    this._ngxUiLoaderService.start();

    this.clientParticipantLink = {
      id: 0,
      clientId: this.clientId,
      participantId: this.selectedParticipant,
      participantName: ''
    };

    this.createResult = await await this._reportService.addClientParticipantLink(this.clientParticipantLink);
    if (this.createResult.success === true) {
      this._toastService.success(this.createResult.message, "Success");
      this.clientParticipantLinks = await this._reportService.GetClientParticipantLinks();
    } else {
      this._toastService.error(this.createResult.message, "Error");
    }


    this._ngxUiLoaderService.stop();
  }

  public async delete(clientParticipantLink: ReportClientParticipantLink): Promise<void> {
    this.createResult = await await this._reportService.removeClientParticipantLink(clientParticipantLink);
    if (this.createResult.success === true) {
      this._toastService.success(this.createResult.message, "Success");
      this.clientParticipantLinks = await this._reportService.GetClientParticipantLinks();
    } else {
      this._toastService.error(this.createResult.message, "Error");
    }
  }


  ngOnInit() {
  }


  public ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
    this.dtTrigger.unsubscribe();
  }
}
